export default __webpack_public_path__ + "media/images/steps/step-4-3d93b74433d3bafb4be40e964ed7b98d.svg";